import * as Sentry from "@sentry/browser";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tracesSampleRate: 0.01,
    integrations: [Sentry.browserTracingIntegration()],
    enableTracing: true,
  });
}
